import { NoItemsCard as NoItemsCardProps } from './NoItemsCard.types'
import { Icon } from 'src/componentsV2/CoreUX/primitives/Icon/Icon'
import { Text } from 'src/componentsV2/CoreUX/primitives/Text/Text'
import './NoItemsCard.scss'

const NoItemsCard = ({ attributes }: NoItemsCardProps) => {
  const { title, description, icon } = attributes
  return (
    <div className="core-ux-lazy-loader-no-items-card">
      <Icon {...icon} />
      <div className="core-ux-lazy-loader-no-items-card__text-container">
        <Text {...title} />
        <Text {...description} />
      </div>
    </div>
  )
}

export default NoItemsCard
